let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("1877j")]).then(() => parcelRequire('c6wmU'));